import OpcoesLentes from '../opcoesLentes/OpcoesLentes';

export default class PrescricaoOculos {
  public id: number;

  public usuarioId: string;

  public tenantId: number;

  public dataPrescricaoOculos: string;

  // Campos para Para Longe - O.D. (Olho Direito)
  public longeOdEsferico?: number;

  public longeOdCilindrico?: number;

  public longeOdEixo?: number;

  public longeOdDnp?: number;

  // Campos para Para Longe - O.E. (Olho Esquerdo)
  public longeOeEsferico?: number;

  public longeOeCilindrico?: number;

  public longeOeEixo?: number;

  public longeOeDnp?: number;

  // Campos para Para Perto - O.D. (Olho Direito)
  public pertoOdEsferico?: number;

  public pertoOdCilindrico?: number;

  public pertoOdEixo?: number;

  public pertoOdDnp?: number;

  // Campos para Para Perto - O.E. (Olho Esquerdo)
  public pertoOeEsferico?: number;

  public pertoOeCilindrico?: number;

  public pertoOeEixo?: number;

  public pertoOeDnp?: number;

  public adicao?: number;

  public observacoes: string;

  public opcoesLentes: OpcoesLentes[];

  constructor() {
    this.id = 0;
    this.usuarioId = '';
    this.tenantId = 0;
    this.dataPrescricaoOculos = '';
    this.observacoes = '';
    this.opcoesLentes = [];
  }
}

